import { LinguiJSMessageDescriptor } from '@lib/types/common'
import { defineMessage } from '@lingui/macro'

type CourseDataType = {
  title: LinguiJSMessageDescriptor
  link: string
}

export const COURSES_DATA: CourseDataType[] = [
  {
    title: defineMessage({ message: `AI and Machine Learning` }),
    link: '/courses/ai-and-machine-learning/',
  },
  {
    title: defineMessage({ message: `Scratch Programming with AI` }),
    link: '/courses/scratch-programming/',
  },
  {
    title: defineMessage({ message: `Python Champion` }),
    link: '/courses/python-for-kids/',
  },
  {
    title: defineMessage({ message: `Game Development for Kids` }),
    link: '/courses/game-development/',
  },
  {
    title: defineMessage({ message: `Website Development` }),
    link: '/courses/web-development/',
  },
  {
    title: defineMessage({ message: `App Development for Kids` }),
    link: '/courses/app-development/',
  },
  {
    title: defineMessage({ message: `AI & Data Science for Teens` }),
    link: '/courses/data-science/',
  },
  {
    title: defineMessage({ message: `Roblox Champion` }),
    link: '/courses/roblox-coding/',
  },
  {
    title: defineMessage({ message: `AP Computer Science A` }),
    link: '/courses/ap-computer-science-a/',
  },
  {
    title: defineMessage({ message: `IOI Algorithms` }),
    link: '/courses/ioi-algorithms-course/',
  },
  {
    title: defineMessage({ message: `Math` }),
    link: '/courses/math/',
  },
  {
    title: defineMessage({ message: `Public Speaking for Kids` }),
    link: '/courses/public-speaking-for-kids/',
  },
  {
    title: defineMessage({ message: `Creative Writing for Kids` }),
    link: '/courses/creative-writing-for-kids/',
  },
]

export const CAMPUS_LINKS: CourseDataType[] = [
  {
    title: defineMessage({ message: `Summer Coding Camp` }),
    link: '/kids-teens-coding-camps/summer/',
  },
  {
    title: defineMessage({ message: `Winter Coding Camp` }),
    link: '/kids-teens-coding-camps/winter/',
  },
  {
    title: defineMessage({ message: `Spring Break Coding Camp` }),
    link: '/kids-teens-coding-camps/spring-break/',
  },
  {
    title: defineMessage({ message: `Black Friday Coding Camp` }),
    link: '/kids-teens-coding-camps/black-friday/',
  },
  {
    title: defineMessage({ message: `Thanksgiving Coding Camp` }),
    link: '/kids-teens-coding-camps/thanksgiving/',
  },
]
